export { RetailPersonalization } from "./retail-personalization.vue";
